export enum FuelType {
    HFO = 1,
    LSF = 2,
    LGO = 3,
    BIO = 4,
}

export const getFuelTypeId = (fuelType: FuelType): number | undefined => {
    return FuelType[fuelType as unknown as keyof typeof FuelType];
};

export const getFuelType = (fuelTypeId: number): FuelType | undefined => {
    return FuelType[fuelTypeId as unknown as keyof typeof FuelType];
};
